const MANAGE_AND_TRACK_FEATURE = [
  {
    src: new URL(
      '~/public/assets/images/Landing/manageAndTrackFeature.png?as=avif',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/avif'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/manageAndTrackFeature.png?as=webp',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/webp'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/manageAndTrackFeature.png',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/png'
  }
]

export default MANAGE_AND_TRACK_FEATURE
